<template>
  <div>
    <div v-if="current === 'MyLoan'">
      <MyLoan />
    </div>
    <div v-else-if="current === 'NoLoan'">
      <NoLoan />
    </div>
    <!-- <div>
      <v-dialog v-model="dialog" persistent max-width="90vw" max-height="90vh">
        <v-card class="pa-4" style="max-height: 100%; overflow-y: auto;">
          <v-card-title class="headline text-h6 text-md-h5">
            A New Chapter in Lending
          </v-card-title>
          <v-card-text class="text-body-2 text-md-body-1">
            <p>
              Some loan applications are moving soon to
              <strong>Century Financial Services</strong>. A fresh, faster, and
              more secure system to improve your borrowing experience.
              In the coming months, you’ll enjoy enhanced features in Century
              Financial Services like:
            </p>
            <ul>
              <li>
                💳 Card payments directly from your profile via
                <strong>Peach Payments</strong>
              </li>
              <li>
                ⚡ Real-time payouts using <strong>PayShap</strong> and your
                <strong>ShapID</strong>
              </li>
              <li>📱 Mobile wallet disbursements for even more convenience</li>
            </ul>
            <br />
            <p>
              <strong>But for now, nothing changes!</strong><br />
              You will be redirected when it’s time to apply through Century
              Financial Services. The switch will be easy and seamless.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dismissDialog">Got it</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";

import MyLoan from "@/components/dashboard/pages/my-loan/MyLoan";
import NoLoan from "@/components/dashboard/pages/my-loan/NoLoan";

export default {
  name: "LimeLoansMain",
  components: { MyLoan, NoLoan },

  data() {
    return {
      current: "",
      dialog: false,
      didReadMigrateNotice: false,
      moreThanThreeLoan: 0,
    };
  },

  computed: {
    ...mapState({ auth: "auth" }),
  },

  created() {
    const user = this.$store.getters["auth/getUser"];
    const getIdNumber = this.auth.idnumber;
    this.moreThanThreeLoan = user.previous_active_loan_count || 0;

    this.didReadMigrateNotice =
      localStorage.getItem(`didReadMigrateNotice_${getIdNumber}`) === "true";

    // Show dialog if they haven't read the notice and had 3+ loans
    this.dialog = this.moreThanThreeLoan >= 3 && !this.didReadMigrateNotice;

    // this.current = "NoLoan";
    if (
      this.auth &&
      this.auth.user &&
      this.auth.user.loans &&
      this.auth.user.loans.length > 0
    ) {
      this.current = "MyLoan";
    } else if (
      this.auth.user.negative_classification ||
      !this.auth.user.can_apply
    ) {
      this.$router.push({ name: "DashboardRefusalPage" });
    } else if (this.auth.user.open_application.can_sign_agreement) {
      this.$router.push({ name: "DashboardSigningLoanAgreementPage" });
    } else if (this.auth.user.has_open_application) {
      // has_arrears
      if (this.auth.user.has_arrears) {
        this.current = "MyLoan";
      } else if (this.auth.user.open_application.has_truid) {
        // this.current = "WaitingForApproval";

        this.$router.push({ name: "DashboardWaitingForApprovalPage" });
      } else if (this.auth.user.open_application.has_bank_statement) {
        // this.current = "WaitingForApproval";

        this.$router.push({ name: "DashboardWaitingForApprovalPage" });
      } else if (!this.auth.user.open_application.has_bank_statement) {
        this.$router.push({ name: "CreateLoanApplicationPage" });
      }
      // else if (!this.auth.user.open_application.has_payslip) {
      //   this.$router.push({ name: "CreateLoanApplicationPage" });
      // }
      else {
        // this.current = "WaitingForApproval";
        this.$router.push({ name: "DashboardWaitingForApprovalPage" });
      }
    } else {
      this.current = "NoLoan";
    }
  },

  mounted() { },

  methods: {
    dismissDialog() {
      this.didReadMigrateNotice = true;
      this.dialog = false;
      const userId = this.auth.idnumber;
      localStorage.setItem(`didReadMigrateNotice_${userId}`, "true");
    },
  },
};
</script>

<style lang="scss" scoped>
//</style>
